/**
 * @file 模型库页菜单
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback} from 'react';
import {Menu} from 'antd';
import {MenuProps} from 'antd/es/menu';

import {IModelBaseMenu} from './type';

export interface IProps {
    menuList: IModelBaseMenu[];
    menuOpenKeys: string[];
    menuActiveKeys: string[];

    onMenuOpenChange: (keys: string[]) => void;
    onMenuActiveChange: (value: string[]) => void;
}

const ModelBaseMenu: React.FC<IProps> = React.memo((props) => {
    const {
        menuList,
        menuOpenKeys,
        menuActiveKeys,

        onMenuOpenChange,
        onMenuActiveChange
    } = props;

    const handleOnMenuOpenChange = useCallback<Exclude<MenuProps['onOpenChange'], undefined>>(
        (keys) => {
            onMenuOpenChange(keys.map(k => '' + k));
        },
        [onMenuOpenChange]
    );

    const handleOnMenuActiveChange = useCallback<Exclude<MenuProps['onSelect'], undefined>>(
        ({selectedKeys = []}) => {
            onMenuActiveChange(selectedKeys.map(k => '' + k));
        },
        [onMenuActiveChange]
    );

    const getSubMenu = (menuList: IModelBaseMenu[]) => {
        return menuList.map(item => {
            if (item.children.length > 0) {
                return (
                    <Menu.SubMenu
                        key={item.id}
                        title={item.name}
                    >
                        {getSubMenu(item.children)}
                    </Menu.SubMenu>
                );
            }
            return (
                <Menu.Item key={item.id}>
                    {item.name}
                </Menu.Item>
            );
        });
    };

    return (
        <div className="model-base-menu">
            <Menu
                onOpenChange={handleOnMenuOpenChange}
                mode="inline"
                openKeys={menuOpenKeys}
                inlineIndent={10}
                onSelect={handleOnMenuActiveChange}
                selectedKeys={menuActiveKeys}
                {...{
                    expandIcon: (
                        <i className="model-base-menu-arrow" />
                    )
                }}
            >
                {getSubMenu(menuList)}
            </Menu>
        </div>
    );
});

export default ModelBaseMenu;
